export default function ContractEA({ isChecked, handleCheckboxChange, handleNextButtonClick }) {
return (
    <div className="container mb100 mt100">
                <div className="beckertitlename mb100 mt100">Becker EA方案</div>
                <div class="card w-75 p-5 m-auto">
                <h5 class="card-title text-black text-center">Becker EA 方案購買須知與同意事項 (請務必詳閱)</h5>
                <div className="br mb-5 mt-3"></div>
                <div class="card-body">
                <p class="card-text m-auto">
                    <div>
                        <ol>
                            <li>
                            <div className="font-weight-bold">訂購與退款規定</div>
                            <ul>
                                <li>
                                訂購流程與猶豫期
                                <ul>
                                    <li>購買前請確認完整審閱此份購買須知與相關規定，審閱期已達五日。</li>
                                    <li>購買方案者保證為完全行為能力人或已得法定代理人同意之限制行為能力人。</li>
                                    <li>購買方案者須完整填寫訂購單、詳閱本購買須知與同意事項並完成繳費，始完成訂購程序。</li>
                                    <li>本商品適用行政院公告「通訊交易解除權合理例外情事」，學員若在 <b>未領取教材、未登入帳號、未參加課程</b> 情況下，於購買後七日內得申請退款。若已使用顧問服務，每階段將酌收 NT$3,000。</li>
                                    <li>軟體教材一經領取或登入帳號後，恕不退費，亦不得要求暫停效期。</li>
                                </ul>
                                </li>
                                <li>
                                帳號與登入管理<br />
                                學員應妥善保管個人帳號與密碼，登入行為將推定為本人操作。若因非 Becker Taiwan 可歸責事由導致帳號外洩，Becker Taiwan 僅提供必要協助，恕不負法律責任。
                                </li>
                                <li>
                                E-mail 通訊義務<br />
                                學員所提供之 E-mail 必須有效期達一年以上，所有帳號通知、課程資訊、系統更新皆以該信箱為唯一正式聯絡方式。若因未定期查收郵件而錯過通知，學員應自負相關責任。
                                </li>
                            </ul>
                            </li>

                            <li>
                            <div className="font-weight-bold">教材與軟體使用規範</div>
                            <ul>
                                <li>
                                授權與效期
                                <ul>
                                    <li>Becker EA Exam Review 材料為美國原版教材與軟體，授權限購買者本人使用，嚴禁轉售、轉贈、共用。違反者將負擔購買總價十倍之懲罰性違約金與其他損害賠償。</li>
                                    <li>軟體授權使用期限為：首次登入日起算 12 個月；如未登入，則自購買日起算 12 個月後自動終止。</li>
                                    <li>為提升服務品質及確保學員正確使用本教材，Becker Professional Education與 Becker Taiwan (捷進) 將蒐集、處理並分析系列產品使用帳號之軟體登錄時間、網路位址 (IP address) 等相關資訊。在任何情況下，系統若發現有多人登錄同一帳號情況， Becker Taiwan (捷進) 有權中止該帳號之軟體權限。</li>
                                </ul>
                                </li>
                                <li>
                                教材與版本管理
                                <ul>
                                    <li>自 2025 年起，Becker EA 方案皆內含電子書教材。</li>
                                    <li>是否含紙本教科書依各方案公告為準：部分方案內含紙本書籍，部分方案則不含，如無內含亦可選擇另行加購。</li>
                                    <li>紙本教科書之加購費用將依 Becker 美國總部之定價 加上國際運費計算。</li>
                                    <li>若學員考試未通過，於帳號效期內可提出「三個月內未及格成績單」或「考場預約證明」，申請購買新版教科書；此項目仍需依照最新版本價格重新加購。</li>
                                    <li>紙本書籍採預購及國際運送機制，寄達台灣時間依海關通關及物流狀況安排，恕無法指定收書時間。</li>
                                </ul>
                                </li>
                                <li>
                                系統需求與連線條件
                                <ul>
                                    <li>
                                    作業系統需求：
                                    <ul>
                                        <li>Windows：Windows 7以上</li>
                                        <li>MacOS：10以上</li>
                                        <li>iOS：13以上（限App）</li>
                                        <li>Android：8以上（限App）</li>
                                    </ul>
                                    </li>
                                    <li>
                                    網路需求：
                                    <ul>
                                        <li>寬頻下載速度 20Mbps 以上</li>
                                        <li>不建議使用公共、社區型或無線網路</li>
                                        <li>動裝置限定使用 APP 版觀看中文課程。</li>
                                        <li>其餘未列示之軟硬體或系統，恕不保證其觀看學習品質。</li>
                                    </ul>
                                    </li>
                                </ul>
                                </li>
                            </ul>
                            </li>

                            <li>
                            <div className="font-weight-bold">中文課程與加值服務（若有購買）</div>
                            <p> 各 EA 方案所含中文加值服務（課程、顧問諮詢、講師解題等）依實際公告為準，購買前請確認方案內容。</p>
                            <ul>
                                <li>
                                中文課程使用原則（適用含中文課程的方案）：
                                <ul>
                                    <li>中文課程包含面授與雲端形式，<b>目前三科總時數為約 36 小時</b>，實際時數依每期公告為準，<b>本條文不視為最終時數承諾</b>。</li>
                                    <li>課程僅限於考試通過前使用，並須於軟體效期內完成。</li>
                                    <li>面授課請假者，可申請補課，補課以雲端形式進行，恕不主動提供額外補課時數。</li>
                                    <li>若曾參加課程但考試未通過，得於課程開課期間，<b>檢附未通過成績單，申請該科中文課程重上一次</b>。</li>
                                </ul>
                                </li>
                                <li>
                                中文課程加購與限制（適用未含中文課程方案）
                                <ul>
                                    <li>未含中文課程之方案購買者，可選擇 加購單堂中文課程（3 小時）NT$1,500 元。</li>
                                    <li>加購者不得使用中文講師線上解題服務。</li>
                                    <li>加購課程需依 Becker Taiwan 開課規劃安排，需提前預約。</li>
                                </ul>
                                </li>
                                <li>
                                中文講師解題服務（適用含中文課程的方案）
                                <ul>
                                    <li>僅限含此項服務之方案使用。次數與使用方式依每期公告為準。</li>
                                    <li>未包含此項服務者，不得以任何形式要求提供中文解題協助。</li>
                                </ul>
                                </li>
                                <li>
                                上課形式與服務調配規則
                                <ul>
                                    <li>方案內含之中文課程，提供面授或雲端上課形式。<b>Becker Taiwan (捷進) 保有各上課形式之開課時間、現場空間開放時間、雲端影片開放時間之最終決定權</b>，學員不得異議。</li>
                                    <li><b>Becker Taiwan (捷進) 保有中文雲端課程於雲端提供時間點、提供內容範圍之決定權</b>，依各期課程影片上架公告為準，學員不得異議。</li>
                                    <li><b>Becker Taiwan (捷進) 保有各項諮詢服務、教室座位、雲端流量資源之分配決定權</b>，學員若欲使用相關服務，須提前來電或來信預約，以確認實體辦公室與面授教室之服務狀態與起迄時間。</li>
                                    <li>學員單科選擇面授型式時，<b>需於軟體效期內選擇一期之該科課程，並預定教室座位名額且完整參加</b>；單科不得要求分期上課。<b>每堂面授課程為三小時，將依該科課堂數自學員使用時數額度中扣除</b>。</li>
                                </ul>
                                </li>
                            </ul>
                            </li>

                            <li>
                            <div className="font-weight-bold">考試顧問諮詢服務（若有購買）</div>
                            <ul>
                                <li>
                                使用資格與方式
                                <ul>
                                    <li>僅限購買「含顧問諮詢服務」之方案使用。內容包含考程規劃、州別選擇、報名與應考流程諮詢。</li>
                                    <li>未包含此項服務者，不得使用任何形式（現場、LINE、電話、電郵等） 詢問報考流程，如有需求可待顧問服務上線後以單次加購方式取得。</li>
                                </ul>
                                </li>
                                <li>
                                顧問服務開放預告
                                <ul>
                                    <li>顧問諮詢服務預計 2025 年 7 月正式啟用。2025 年 6 月起販售之方案於 7 月前暫不提供諮詢服務。</li>
                                </ul>
                                </li>
                            </ul>
                            </li>

                            <li>
                            <div className="font-weight-bold">其他條款</div>
                            <ul>
                                <li>
                                契約終止條款
                                <ul>
                                    <li>學員若違反本契約條款或社會公序良俗，或限期改善未果，Becker Taiwan 得終止契約且不退費。</li>
                                </ul>
                                </li>
                                <li>
                                持續展延 (Unlimited Access) 條款（若有包含於方案內）
                                <ul>
                                    <li>購買包含持續展延資格之方案者，於效期內得提供考場預約證明，申請展延單科 4 個月，並以原到期日翌日為起算日。需於期限前提出申請。</li>
                                    <li>軟體效期若獲免費展延，延長之效期起算日為原有到期日之隔天，不得提早或延後起算。</li>
                                </ul>
                                </li>
                                <li>
                                考試資格聲明
                                <ul>
                                    <li>Becker Taiwan 所提供之報考建議或流程說明，僅供參考。考試資格依美國政府官方核發單位或審查機構最終裁定為準。</li>
                                </ul>
                                </li>
                                <li>
                                教材供應與變更聲明
                                <ul>
                                    <li>原廠 Becker Professional Education 若有停產或規格調整，Becker Taiwan 保有調整或停止供貨之權利，恕不另行賠償。</li>
                                </ul>
                                </li>
                                <li>
                                補習班合法登記與保障
                                <ul>
                                    <li>Becker Taiwan 為合法補習業者，並加入補教品保協會聯合保證制度。若遇重大變故無法繼續提供課程，得向其他協定補習班申請等值課程兌換。</li>
                                </ul>
                                </li>
                            </ul>
                            </li>

                            <li>
                            <div className="font-weight-bold">個資保護聲明</div>
                            <ul>
                                <li>
                                捷進顧問有限公司感謝您訂購 Becker 教材方案。本公司依個人資料保護法第8條第1項之要求，蒐集並管理學員之個人資料如下：
                                <ul>
                                    <li>蒐集目的：依照101年10月1日修正之個人資料保護法之特定目的及個人資料之類別，040行銷、069契約、類似契約或其他法律關係事務、090消費者客戶管理與服務、157調查、統計與研究分析、181其他經營合於營業登記項目或組織章程所定之業務182其他諮詢與顧問服務。</li>
                                    <li>個人資料類別： C001電子郵件、中文姓名、英文拼音全名、電話號碼。C002金融機構帳戶號碼與姓名。C003身分證字號。C036是否曾訂購本公司產品、得知本公司之管道。C038在職身分C051所屬或畢業學校與科系。</li>
                                    <li>個人資料利用之期間、地區：我們會在您使用本公司提供服務之期間與地區利用您的個人資料。</li>
                                    <li>個人資料利用對象及方法：本公司將會依照您所填寫之訂購資料，確認您已完成訂購，並替您註冊帳號、寄送商品、提供學員管理、行銷活動等服務。並將分析您提供之類別C036、C038、C051等資訊，以增進本公司之服務。在未經您的同意下，我們不會將您的個人資料提供給第三人或做不當利用。</li>
                                    <li>如您所提供之個人資料不正確或不完整，可能將無法完整履行訂購單內容。</li>
                                    <li>您得行使個資法第3條所賦予之相關權利，如您欲行使該權利請來信<br /> service@beckertw.com。</li>
                                </ul>
                                </li>
                            </ul>
                            </li>
                        </ol>
                        </div>

                </p>

                <div className="text-center">
                    <label>
                    <input className="m-2" type="checkbox" value="read" checked={isChecked} onChange={handleCheckboxChange} required />
                    <span>我已詳閱並且了解</span>
                    </label>
                    <div className="btn btn-primary m-3" onClick={handleNextButtonClick}>下一步</div>
                </div>
                </div>
            </div>
            </div>
  );
}
